// extracted by mini-css-extract-plugin
export default {"imageWrapper":"jJ-z","hovered":"kJ-z","hoverImage":"lJ-z","mainImage":"mJ-z","imageNoBackground":"nJ-z","fullSizeImage":"oJ-z"};